<template>
  <div class="block">

    <tag-modal
      :isModalVisible="showTagModal"
      :tags="tags"
      @addtag="addTagToQuery"
      @rmtag="rmTagFromQuery"
      @close="showTagModal = false" />

    <div>
      <div v-if="spellKind === 'SMS'">
        <div class="w-full">
          <t-field>
            <div class="text-sm font-bold pb-2">What should it say?</div>
            <div ref="note"></div>
          </t-field>

          <!-- <t-field>
               <div class="text-sm font-bold pb-2">Save the text as a note?</div>
               <t-rads v-model="save" :opts="[{name: 'No', value: false}, {name: 'Yes', value: true}]" />
               </t-field> -->
        </div>
        <div class="w-full">
          <scheduler v-model="schedule" :spellKind="spellKind" />
        </div>
      </div>

      <div v-if="spellKind === 'NOTE'">
        <div class="w-full">
          <t-field>
            <div class="text-sm font-bold pb-2">What note do you want to save?</div>

            <t-field>
              <div ref="note"></div>
            </t-field>
          </t-field>

        </div>
        <div class="w-full">
          <scheduler v-model="schedule" :spellKind="spellKind" />
        </div>
      </div>

      <div v-if="spellKind === 'REMINDER_EMAIL'">
        <div class="w-full">
          <div class="text-sm font-bold pb-2"></div>
          <t-field>
            <div class="text-sm font-bold pb-2">Subject</div>
            <t-text-input v-model="subject" />
          </t-field>
          <t-field>
            <div class="text-sm font-bold pb-2">Email Body</div>
            <t-field>
              <div ref="note"></div>
            </t-field>
          </t-field>
        </div>
        <div class="w-full">
          <scheduler v-model="schedule" :spellKind="spellKind" />
        </div>
      </div>

      <div v-if="spellKind === 'CONNECTION_SEND'">
        <div class="w-full">
          <t-field>
            <div class="text-sm font-bold pb-2">Choose connection</div>
            <select v-model="connectionId" class="block bg-white px-1 py-2">
              <option v-for="c in connections" :value="c.id">
                <span v-if="c.type==='SIGNAL'">Signal Number {{formatIntlNumber(c.target)}}</span>
                <span v-else-if="c.type==='TELEGRAM'">Telegram Account @{{(c.target_info.username)}}</span>
              </option>
            </select>
          </t-field>

          <t-field>
            <div class="text-sm font-bold pb-2">What should it say?</div>
            <div ref="note"></div>
          </t-field>
        </div>
        <div class="w-full">
          <scheduler v-model="schedule" :spellKind="spellKind" />
        </div>
      </div>

      <div v-else-if="['EMAIL', 'DONE_EMAIL', 'TODO_EMAIL'].indexOf(spellKind) !== -1">
        <div class="w-full">
          <t-field>
            <div class="flex justify-between">
              <div class="text-sm font-bold pb-2">Choose folder</div>
              <div class="text-xs text-full-blue underline pb-2"
                @click="showTagModal=true">
                Filter Tags
                <span v-if="tags && tags.length > 0"
                  class="font-bold">({{tags.length}})</span>
              </div>
            </div>
            <path-autocomplete @input="handleSearchSelect" :value="pathTerm" />
          </t-field>

          <t-field>
            <div class="text-sm font-bold pb-2">Filter notes by time</div>
            <t-rads v-model="interval" :opts="[
                                       {name: 'All time', value: 'ALL'},
                                       {name: 'Past day', value: 'DAY'},
                                       {name: 'Past week', value: 'WEEK'},
                                       {name: 'Past month', value: 'MONTH'},
                                       {name: 'Past year', value: 'YEAR'}
                                       ]" />
          </t-field>
        </div>
        <div class="w-full">
          <scheduler v-model="schedule" :spellKind="spellKind" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
 import {mapState, mapActions} from 'vuex';
 import { DateTime } from 'luxon';
 import api from '@/api';
 import editorFactory from '@/editorFactory'
 import TagModal from '@/components/TagModal';
 import Scheduler from '@/components/spells/Scheduler';
 import PathAutocomplete from '@/components/PathAutocomplete';
 import TagList from '@/components/TagList';
 import spellHelper from './spellHelper';

 import { parsePhoneNumberFromString } from 'libphonenumber-js';


 export default {
   props: {
     value: {
       type: Object,
       default: () => ({})
     },
     defaultText: {
       type: String,
       default: ''
     },
     defaultConnectionId: {
       type: String,
       default: ''
     },
     defaultSpellKind: {
       type: String,
       default: 'EMAIL'
     },
     defaultTags: {
       type: Array,
       default: () => ([])
     },
     defaultPath: {
       type: String,
       default: '/'
     },
     defaultNoteType: {
       type: String,
       default: 'ALL'
     },
     defaultPayload: {
       type: Object,
       default: () => ({text:''})
     }
   },
   data () {
     const func = this.value.fn || {};

     return {
       spellKind: spellHelper.prog(func, this.defaultSpellKind),
       text: spellHelper.text(func, this.defaultText),
       payload: spellHelper.payload(func, this.defaultPayload),
       subject: spellHelper.subject(func, this.defaultText),
       save: spellHelper.save(func, false),
       interval: spellHelper.interval(func, 'DAY'),
       pathTerm: spellHelper.path(func, this.defaultPath),
       todoSelect: spellHelper.type(func, this.defaultNoteType),
       tags: spellHelper.tags(func, this.defaultTags),
       error: '',
       schedule: {
         timestamp: this.value.start_from,
         freq: this.value.mode,
       },
       connectionId: spellHelper.connectionId(func, this.defaultConnectionId),
       showTagModal: false,
     }
   },

   components: {PathAutocomplete, TagModal, TagList, Scheduler},

   async created () {
     this.$emit('input', this.compiledPig);

     if (this.spellKind === 'CONNECTION_SEND') {
       this.getVerifiedConnections()
     }
   },

   mounted () {
     if (['NOTE', 'SMS', 'REMINDER_EMAIL', 'CONNECTION_SEND'].indexOf(this.spellKind) !== -1) {
       this.mountCM();
     }
   },

   computed: {
     ...mapState({
       paths: state => state.pathsList,
       member: state => state.member,
       connections: state => state.verifiedConnections
     }),

     query () {
       const conditions = [{
         entity: 'PATH',
         term: this.pathTerm || '/'
       }];

       if (this.tags && this.tags.length) {
         conditions.push({
           entity: 'TAG',
           term: this.tags
         })
       }

       if (this.spellKind === 'TODO_EMAIL') {
         conditions.push({
           entity: 'TODO',
           term: 'TODO'
         });
       } else if (this.spellKind === 'DONE_EMAIL') {
         conditions.push({
           entity: 'TODO',
           term: 'DONE'
         });
       }

       return {
         AND: conditions
       }
     },

     run () {
       const run = {};

       if (this.spellKind === 'SMS') {
         run.SMS = {
           text: this.text,
           save: this.save
         }
       } else if (this.spellKind === 'REMINDER_EMAIL') {
         run.REMINDER_EMAIL = {
           text: this.text,
           subject: this.subject
         }
       } else if (this.spellKind === 'CONNECTION_SEND') {
         run.CONNECTION_SEND = {
           payload: {text: this.text},
           connection_id: this.connectionId
         }
       } else if (this.spellKind === 'NOTE') {
         run.NOTE = {
           text: this.text
         }
       }  else if (this.spellKind === 'EMAIL') {
         run.EMAIL = {
           tmpl: 'NOTE',
           query: {
             interval: this.interval
           }
         }

         run.EMAIL.query.records = this.query;
       } else if (this.spellKind === 'DONE_EMAIL') {
         run.DONE_EMAIL = {
           tmpl: 'DONE',
           query: {
             interval: this.interval,
             ts_type: 'updated'
           }
         }

         run.DONE_EMAIL.query.records = this.query;
       } else if (this.spellKind === 'TODO_EMAIL') {
         run.TODO_EMAIL = {
           tmpl: 'TODO',
           query: {
             interval: this.interval
           }
         }

         run.TODO_EMAIL.query.records = this.query;
       }

       return run;
     },

     fn () {
       return {
         version: 1,
         run: this.run
       }
     },

     compiledPig () {
       return {
         fn: this.fn,
         name: this.schedule.timestamp,
         start_from: DateTime.fromISO(this.schedule.timestamp).toISO(),
         // .toFormat('yyyy-LL-dd\'T\'HH:mm'),
         mode: this.schedule.freq,
         at_hour: DateTime.fromISO(this.schedule.timestamp).toFormat('HH'),
         at_minute: DateTime.fromISO(this.schedule.timestamp).toFormat('mm'),
         tzid: Intl.DateTimeFormat().resolvedOptions().timeZone,
       }
     }
   },

   methods: {
     ...mapActions(['getVerifiedConnections']),

     entitySearch (input) {
       return this.paths.filter(p => {
         return p.startsWith(input)
       })
     },

     handleSearchSelect (r) {
       this.pathTerm = r;
     },

     addTagToQuery (t) {
       this.tags.push(t);
     },

     rmTagFromQuery (t) {
       const index = this.tags.indexOf(t);

       if (index === -1) {
         return;
       }
       this.tags.splice(index, 1);
     },

     async mountCM () {
       const vm = this;
       this.cm = await editorFactory({
         elm: this.$refs.note,
         text: this.text || '',
         onSubmit: this.addNote,
         onChange: (txt) => { // this also fires immediately...
           vm.text = txt
         },
         placeholder: ''
       })

     },

     formatIntlNumber (input) {
       if (!input) {
         return
       }
       const phoneNumber = parsePhoneNumberFromString(input)
       return phoneNumber.formatInternational()
     },
   },

   watch: {
     compiledPig(to) {
       if (to) {
         this.$emit('input', to);
       }
     }
   }
 }

</script>
